import React from 'react';

export const getFilterOption = (children: any, input: any) =>
  children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

export const getOptions = (
  Option: any,
  options: { value: string; text: string }[],
) =>
  options.map(({ value, text }) => (
    <Option key={value} value={value}>
      {text}
    </Option>
  ));
